import { render } from "./Cotas.vue?vue&type=template&id=74842220"
import script from "./Cotas.vue?vue&type=script&lang=js"
export * from "./Cotas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__